import React from 'react';
import { Button, Box, Paper, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';

import { Loading, DataItem } from './components';
import useStyles from './styles';

import RenderIf from '../../../../renderIf';

const Card = ({ appInst = {}, displayKeys }) => {
    const classes = useStyles();
    const history = useHistory();

    let displayName = appInst?.StudentName && appInst.StudentName?.trim?.() !== '' ? appInst.StudentName : 'No Name'; //TODO #TechnicalDebt Eventually work this into the configuration of the card.

    return (
        <Paper
            sx={{
                margin: (theme) => theme.spacing(5),
                borderRadius: '8px',
                padding: (theme) => theme.spacing(4),
                paddingLeft: (theme) => theme.spacing(6),
            }}
        >
            <Typography sx={{ fontSize: '1.5rem', color: (theme) => theme.palette.primary.main, fontWeight: 700 }}>
                {appInst.ID !== 'loading' ? displayName : <Loading />}
            </Typography>
            <Typography>{appInst?.Term ? appInst.Term : <Loading width={150} />}</Typography>

            <Box className={classes.appDataStack}>
                <RenderIf isTrue={typeof displayKeys?.map === 'function'}>
                    {displayKeys?.map?.((displayObj) => {
                        return (
                            <DataItem
                                appInst={appInst}
                                displayObj={displayObj}
                            />
                        );
                    })}
                </RenderIf>
            </Box>

            <RenderIf isTrue={appInst.ID !== 'loading'}>
                <Button
                    sx={{
                        marginTop: (theme) => theme.spacing(3),
                        height: '3rem',
                        borderRadius: '8px',
                    }}
                    variant="contained"
                    onClick={() => history.push(`/application/${appInst.ID}`)}
                >
                    {/* TODO #TechnicalDebt - This action, its onclick functionality and the label should come from the database eventually */}
                    {[1, 3].includes(appInst?.Status) || [1, 3].includes(appInst?.Status?.id) ? 'Edit' : 'View'} application
                </Button>
            </RenderIf>

            <RenderIf isTrue={appInst.ID === 'loading'}>
                <Box
                    sx={{
                        marginTop: (theme) => theme.spacing(3),
                        height: '3rem',
                        width: '140px',
                    }}
                >
                    <Loading
                        height="100%"
                        width="100%"
                    />
                </Box>
            </RenderIf>
        </Paper>
    );
};

export default Card;
